<template>
  <div class="rental">
    <app-spinner v-if="!is_loaded" />
    <template v-else>
      <v-client-table
        :data="table.items"
        :columns="table.columns"
        :options="table.options"
        class="table-default table-default--40"
      >
        <template #checklist="{ row }">
          <a
            v-if="row.attachment"
            :href="row.attachment.file"
            target="_blank"
            class="status-tag"
            style="background-color: #439ad1"
          >
            View
          </a>
          <template v-else>-</template>
        </template>
        <template #amount="{ row }">{{ formatAmount(row.amount) }} $</template>
      </v-client-table>
    </template>
  </div>
</template>

<script>
import { getFinancePaymentsOnSiteGears } from '@/http'

export default {
  name: 'RentalPayments',
  data() {
    return {
      table_preloader: false,
      is_loaded: false,
      table: {
        items: [],
        columns: [
          'checklist',
          'amount',
        ],
        options: {
          headings: {
            'checklist': 'Checklist',
            'amount': 'Amount',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 100,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
    }
  },
  created() {
    this.fetchItems()
  },
  methods: {
    fetchItems() {
      getFinancePaymentsOnSiteGears({ rental: this.$route.params.id })
        .then(response => {
          this.table.items = response.data
          this.is_loaded = true
        })
    },
    formatAmount(string) {
      return string ? Intl.NumberFormat('ru-RU').format(string) : '-'
    },
  }
}
</script>
